import { styled } from 'stitches.config'
import { recipeColorVariant } from 'features/ECommerce/screens/ProductDetail/FivePound/components/Hero/Hero.styles'

export const ItemCounterWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto',
  gap: '4px',
  flexDirection: 'row',
  marginBottom: '$4',
  marginTop: '$1',
})

export const CounterIcon = styled('div', {
  borderRadius: '8px',
  background: '$tertiary-200',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50px',
  width: '50px',
  userSelect: 'none',

  '&:hover, &:focus': {
    background: '$tertiary-200',
  },

  variants: {
    disabled: {
      true: {
        cursor: 'not-allowed',
      },
    },
    ...recipeColorVariant,
  },

  defaultVariants: {
    recipe: 'default',
  },
})

export const Counter = styled(CounterIcon, {
  background: '$accent-white',
  border: 'solid',
  borderWidth: '1px',
  borderColor: '$primary-700',

  '&:hover, &:focus': {
    background: '$accent-white',
  },

  defaultVariants: {
    recipe: {
      background: '$accent-white',
      '&:hover, &:focus': {
        background: '$accent-white',
      },
    },
  },
})
